module.exports = __webpack_public_path__ + "img/4.15d00d54.png";